// @flow
import React from 'react'
import Video from '../Video/video'
import type { VideoProps } from '../../types'
import styles from './videoList.css'

type Props = {
  videos: Array<VideoProps>
}

export default ({videos}: Props) => (
  <ul className={styles.videoList}>
    <div className={styles.videoheader}>
      <h2>Se møtene</h2>
      <p>Her møter fem tidligere elever en lærer som var noe helt spesielt i livene deres.</p>
    </div>
    {typeof videos !== 'undefined' && videos.map((video, index) => (
      <Video
        key={`${video.videoId}-${index}`}
        videoId={video.videoId}
        poster={video.poster}
        subtitle={video.subtitle}
        quote={video.quote}
        name={video.name} />
    ))}
  </ul>
)



// WEBPACK FOOTER //
// ./src/shared/components/VideoList/videoList.js